import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserContextProvider } from './context/userContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { checkForNewBuildAndReload } from "./version_refresher";

// favicon (IMPORT harus di atas)
import Favicon from './assets/ysb/logo-ysb.png';

checkForNewBuildAndReload();

// ====== BONUS: auto reload 1x kalau ada mismatch chunk setelah deploy ======
const setupChunkReloadGuard = () => {
  const reloadOnce = () => {
    const key = 'did-reload-for-new-version';
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    window.location.reload();
  };

  const isChunkError = (msg) => {
    const m = String(msg || '');
    return (
      m.includes('Loading chunk') ||
      m.includes('ChunkLoadError') ||
      m.includes('Loading CSS chunk') ||
      m.includes('dynamically imported module') ||
      m.includes('Importing a module script failed')
    );
  };

  window.addEventListener('error', (e) => {
    if (isChunkError(e?.message)) reloadOnce();
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason = e?.reason;
    if (isChunkError(reason?.message || reason)) reloadOnce();
  });
};

setupChunkReloadGuard();
// =======================================================================

// set favicon (kode boleh di bawah)
const favicon = document.getElementById('idFavicon');
if (favicon) favicon.setAttribute('href', Favicon);

const client = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <UserContextProvider>
      <QueryClientProvider client={client}>
        <Router>
          <ProSidebarProvider>
            <App />
          </ProSidebarProvider>
        </Router>
      </QueryClientProvider>
    </UserContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
